import { evolve, Iterator, map } from 'rambda';
import { PaginatedListResultDTO } from '@higo/api/src/models';

export const mapPaginatedListResult = <T, U>(
  mapFn: Iterator<T, U>,
): ((a: PaginatedListResultDTO<T>) => PaginatedListResultDTO<U>) =>
  evolve({
    content: map(mapFn),
  });
